import { BaseModel } from "model/BaseModel";
import Processo from "./Processo";
import UnidadeOrganizacional from "./UnidadeOrganizacional";
import Periodicidade from "model/periodicidade/Periodicidade";
import Usuario from "model/administracao/cadastro/Usuario";
import { IndicadorMeta } from "./IndicadorMeta";
import IndicadorDashboardItem from "./IndicadorDashboardItem";

export default class Indicador implements BaseModel{
    id: number | null;
    processo: Processo | null;
    unidadeOrganizacional: UnidadeOrganizacional | null;
    codigo: string;
    nome: string;
    unidadeMedida: string | null;
    tipoAcumuloValor: string;
    periodicidadeColeta: Periodicidade | null;
    usuarioColeta: Usuario | null;
    dataInicioColeta: Date | null;
    dataProximaColeta: Date | null;
    temMeta: boolean;
    temAnalise: boolean;
    usuarioAnalise: Usuario | null;
    metas: IndicadorMeta[];
    itens: IndicadorDashboardItem[] = [];
    analisesPendentes: number = 0;

    constructor(
        id  = 0,
        processo = null,
        unidadeOrganizacional = null,
        codigo = '',
        nome = '',
        unidadeMedida = null,
        tipoAcumuloValor = 'T',
        periodicidadeColeta = null,
        usuarioColeta = null,
        dataInicioColeta: Date | null = null,
        dataProximaColeta: Date | null = null,
        temMeta = false,
        temAnalise = false,
        usuarioAnalise = null,
        metas = []
    ){
        this.id = id;
        this.processo = processo;
        this.unidadeOrganizacional = unidadeOrganizacional;
        this.codigo = codigo;
        this.nome = nome;
        this.unidadeMedida = unidadeMedida;
        this.tipoAcumuloValor = tipoAcumuloValor;
        this.periodicidadeColeta = periodicidadeColeta;
        this.usuarioColeta = usuarioColeta;
        this.dataInicioColeta = dataInicioColeta;
        this.dataProximaColeta = dataProximaColeta;
        this.temMeta = temMeta;
        this.temAnalise = temAnalise;
        this.usuarioAnalise = usuarioAnalise;
        this.metas = metas;
    }
}